export const SLA_VIEW_MODE_CARD = 'card' as const;
export const SLA_VIEW_MODE_QUEUE = 'queue' as const;
export const SLA_VIEW_MODE_INSIGHTS = 'insights' as const;
